import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main.component';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from '../core/core.module';
import { PrivacyPolicyComponent } from '../platform/modules/login/privacy-policy.component';
import { DownloadFileComponent } from '../platform/modules/download-file/download-file.component';
import { Location } from '@angular/common';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        redirectTo: 'consults',
        pathMatch:'full'
      },
      {
        path: 'metrics',
        loadChildren: () => import('./metrics/metrics.module').then( m => m.MetricsModule )
      },{
        path: 'consults',
        loadChildren: () => import('./consults/consults.module').then( m => m.ConsultsModule )
      },{
        path: 'doctors',
        loadChildren: () => import('./doctors/doctors.module').then( m => m.DoctorsModule )
      },{
        path: 'hospitals',
        loadChildren: () => import('./hospitals/hospitals.module').then( m => m.HospitalsModule )
      },{
        path: 'programs',
        loadChildren: () => import('./programs/programs.module').then( m => m.ProgramsModule )
      },{
        path: 'users',
        loadChildren: () => import('./users/users.module').then( m => m.UsersModule )
      },{
        path: 'team',
        loadChildren: () => import('./teams/teams.module').then( m => m.TeamsModule )
      },{
        path: 'timesheet',
        loadChildren: () => import('./timesheet/timesheet.module').then( m => m.TimesheetModule )
      }
      // to update
      ,{
        path: 'privacy',
        component: PrivacyPolicyComponent
      },
      {
        path: 'web',
        loadChildren: () => import('src/app/platform/platform.module').then(x => x.PlatformModule)
      },
      {
        path: 'webadmin',
        loadChildren: () => import('src/app/super-admin-portal/super-admin-portal.module').then(x => x.SuperAdminPortalModule)
      },
      {
        path: '.well-known/apple-app-site-association',
        component: DownloadFileComponent
      }
    ]
  }
]

@NgModule({
  declarations: [
    MainComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    RouterModule.forChild(routes)
  ],
  providers: [Location]
})
export class MainModule { }
